<template>
    <div class="large-background-outer">
        <div class="outer-content">
            <div class="large-background"></div>
        </div>
        <div class="dark-overlay" v-if="IsDark"></div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    name: 'LargeBackground',
    props: {
        IsDark: Boolean
    },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.large-background {
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    position: absolute;
    background-size: cover;
    background-image: url("../assets-fca/Background Elements/large-background.svg");
    background-position-x: center;
}

.large-background-outer {
    background-color: black;
    position: absolute;
    width: 100%;
    height: 100%;
}

.dark-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #40465E;
    opacity: 0.5;
}

/*
    .large-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #7DCFDA;
    z-index: -1;
}

.large-background-dark {
    background-color: #2d4b4f;
}

.cloud1 {
    left: 1056.03px;
    top: 203px;
    height: 110.54px;
    width: 274.04px;
}

.cloud2 {
    left: 125px;
    top: 240.12px;
    Width: 182.03px;
    Height: 73.42px;
}

.land {
    height: 642.03px;
    width: 100%;
    background-color: #4F7F58;
    position: absolute;
    top: 424px;
    z-index: -2;
}

.darkOverlay {
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.7;
}

.background_river {
    overflow: hidden;
    position: absolute;
    top: 630px;
    left: 0px;
}

.background_river2 {
    overflow: hidden;
    position: absolute;
    top: 630px;
    left: 1566px;
}

.background_river_right {
    .background_river;
    left: 1366px;
    transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
}

.background_river_left {
    .background_river;
    left: -1366px;
    transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
}


.BG_river, .BG_river2 {
    Width: 2681.19px;
    Height: 210px;
    overflow: hidden;
    background: url("../invision/river.svg");
    background-size: cover;
}



#background_mountain {
    height: 257px;
    width: 1366px;
    position: absolute;
    top: 334px;
}

.BG_mountain {
    width: 1633px;
    margin-left: -133px;
}

#background_mountain_left {
    height: 257px;
    width: 1366px;
    position: absolute;
    top: 465px;
}

.BG_mountain_left {
    width: 1128px;
    margin-left: 1410px;
}

#background_mountain_back {
    height: 257px;
    width: 1366px;
    position: absolute;
    top: 334px;
    z-index: -1;
}

.BG_mountain_back {
    width: 1258px;
    margin-left: 1440px;
}

#background_mountain_back2 {
    height: 257px;
    width: 1366px;
    position: absolute;
    top: 334px;
    z-index: -1;
}

.BG_mountain_back2 {
    width: 1258px;
    margin-left: -1510px;
}

#background_mountain_large {
    height: 257px;
    width: 1366px;
    position: absolute;
    top: 465px;
    transform: scaleX(-1);
}

.BG_mountain_large {
    width: 1128px;
    margin-left: 1515px;
}

#background_marae {
    height: 922px;
    width: 436px;
    position: absolute;
    top: 486px;
    left: 922px;
}

#background_clouds {
    height: 111px;
    width: 1205px;
    position: absolute;
    top: 193px;
    left: 125px;
}

#background_bushes {
    height: 431px;
    width: 1366px;
    position: absolute;
    top: 595px;
}

.BG_bushes {
    width: 1702px;
    margin-left: -168px;
    margin-top: 80px;
}

.inner-content {
    overflow: visible;
}

.outer-content {
    overflow: visible;
}
    */
</style>